import React from 'react';
import { Status } from 'generated/graphql';
import { CompleteQueryProps, UserDialogProps } from '../CompleteQuery';
import { CompleteDistributionDialog } from './CompleteDistributionDialog';
import { CompleteQueryDialog } from './CompleteQueryDialog';

export type CompleteQueryDialogProps = UserDialogProps & Pick<CompleteQueryProps, 'status'>;

export const CompleteQueryStrategy: React.FC<CompleteQueryDialogProps> = (props) => {
  const { id, open, closeConfirmationDialog, user, distributions, status, setResultMessage } =
    props;

  const isInternalUserAndQueryIsAnswered = user?.internal && status === Status.ANSWERED;

  return isInternalUserAndQueryIsAnswered ? (
    <CompleteQueryDialog
      id={id}
      open={open}
      closeConfirmationDialog={closeConfirmationDialog}
      setResultMessage={setResultMessage}
    />
  ) : (
    <CompleteDistributionDialog
      id={id}
      open={open}
      closeConfirmationDialog={closeConfirmationDialog}
      user={user}
      distributions={distributions}
      setResultMessage={setResultMessage}
    />
  );
};
